// removed by extract-text-webpack-plugin
module.exports = {"InnerContainer":"_1AZ1x","TabList":"_3jrsy","TabItem":"_1VXCf","TabItemActive":"_1FuMc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Tuple/TupleInner/TupleInner.scss
// module id = 512
// module chunks = 0